import { AwardDto, CompletedChallenge, NotCompletedChallenge } from '../dao/core-dao'
import { coreService } from '../service/core-service'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { queryKeys } from 'src/util/query-keys'

export const useProgrammeAwards = (): UseQueryResult<AwardDto[], Error> => {
  return useQuery<AwardDto[], Error>(queryKeys.programmeAwards(), () => coreService.getMyProgrammeAwards())
}

export const useCompletedChallenges = (limit?: number): UseQueryResult<CompletedChallenge[], Error> => {
  return useQuery<CompletedChallenge[], Error>(queryKeys.completedChallenges(), () =>
    coreService.getCompletedChallenges({ limit }),
  )
}

export const useNotYetCompletedChallenges = (): UseQueryResult<NotCompletedChallenge[], Error> => {
  return useQuery<NotCompletedChallenge[], Error>(queryKeys.notYetCompletedChallenges(), () =>
    coreService.getNotYetCompletedChallenges(),
  )
}
